<template>
    <div id='Top'>
        <div class="top">
            <div :class="'op_btn ' + op_btn_class" @click="to_jump()"></div>
        </div>


    </div>

</template>

<script>
import vue from "vue";

export default vue.component('Top', {
    components: {
    },
    props: {
        chn: String,
    },
    data() {
        return {

        }
    },
    created() {
        // let image = new Image()
        // image.src = "//whhxparty.ehijoy.com/img/whhx_party/friend_invitation_act/game/plot_bg_1.png"
    },
    mounted() {

    },
    methods: {
        to_jump() {
            var k = this.op_btn_class
            this[k]()
        },
        share() {
            console.log(this.op_btn_class)
            this.$game_config.copy_txt('https://whhxparty.ehijoy.com/pic_find_holes_guest/index.html')
            var msg = { title: '链接已复制', con: '您可分享给好友，一同帮助云梦勘图解密' }
            this.$eventBus.$emit('show_dialog', msg)
        },
        download() {
            console.log(this.op_btn_class)
            var url = this.$game_config.get_download_url(this.chn)
            url && (window.location.href = url)
        },



    },
    computed: {
        type() {
            // 游戏页面 只能分享
            var r = this.$game_config.gfb_chn(this.chn) ? 'download' : 'share'
            return r
        },

        op_btn_class() {
            return this.type == 'share' ? 'share' : 'download'
        }

    }

})
</script>

<style scoped>
#Top {
    z-index: 5;
    position: fixed;
}

.top {
    display: flex;
    flex-flow: row-reverse;
    width: 1080px;
    height: 186px;
    background-image: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/top/top_bg.png');
    background-repeat: no-repeat;
    background-size: 100%;
}

.top .op_btn {
    width: 318px;
    height: 85px;
    background-repeat: no-repeat;
    background-size: 100%;
    margin-right: 20px;
    margin-top: 33px;
}

.top .share {
    background-image: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/top/top_share.png');
}

.top .download {
    background-image: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/top/top_download.png');
}
</style>